import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
var designCategory = {
  namespaced: true,
  state: {
    select_id: '',
    // 选中id
    select_com: '',
    // 选中的组件
    pageData: '',
    // 页面数据
    show_component_form: false,
    // 是否显示配置页面
    langId: 2,
    // iframe中的语言id
    select_right_com: '',
    select_right_id: '',
    select_right_index: 0,
    select_simple_com: '',
    select_simple_index: 0,
    show_simple_form: false,
    scale: 100,
    maxScale: 200,
    minScale: 45,
    imgHost: '',
    showOp: false,
    // 显示操作栏
    showSimpleOp: false // 显示一级菜单的操作栏
  },
  mutations: {
    setShowSimpleOp: function setShowSimpleOp(state, data) {
      state.showSimpleOp = data;
    },
    simpleFormClose: function simpleFormClose(state) {
      state.show_simple_form = false;
    },
    setSelectedId: function setSelectedId(state, id) {
      state.select_id = id;
    },
    setSelectedCom: function setSelectedCom(state, com) {
      state.select_com = com;
    },
    setPageData: function setPageData(state, data) {
      state.pageData = data;
    },
    setShowComponentForm: function setShowComponentForm(state, data) {
      state.show_component_form = data;
    },
    setSelectRightId: function setSelectRightId(state, data) {
      state.show_component_form = true;
      state.select_right_id = data;
    },
    setSelectRightCom: function setSelectRightCom(state, data) {
      state.select_right_com = data;
    },
    set_scale: function set_scale(state, data) {
      var num = parseInt(data);
      if (num > state.maxScale) {
        num = state.maxScale;
      }
      ;
      if (num < state.minScale) {
        num = state.minScale;
      }
      ;
      state.scale = num;
    },
    setImgHost: function setImgHost(state, data) {
      state.imgHost = data;
    },
    setSelectSimpleCom: function setSelectSimpleCom(state, data) {
      state.select_simple_com = data;
    },
    setShowSimpleForm: function setShowSimpleForm(state, data) {
      state.show_simple_form = data;
    },
    setShowOp: function setShowOp(state, data) {
      state.showOp = data;
    }
  },
  getters: {
    // getIndex(state){
    //     if (!state.selectedId || !state.pageData) return 0
    //     let index;
    //     state.pageData.catelist.forEach((item, i) => {
    //         if (item.id === this.selectedId){
    //             index = i
    //         }
    //     })
    //
    //     return index
    // }
  },
  actions: {
    // 页面加载
    pageLoad: function pageLoad(_ref) {
      var commit = _ref.commit,
        dispatch = _ref.dispatch;
    },
    formClose: function formClose(_ref2) {
      var commit = _ref2.commit;
      commit('setShowComponentForm', false);
    },
    formOpen: function formOpen(_ref3, id) {
      var state = _ref3.state,
        commit = _ref3.commit;
      if (state.select_com && state.select_id === id) {
        commit('setShowComponentForm', true);
      } else {
        if (state.pageData) {
          var com = state.pageData.catelist.filter(function (item) {
            return item.id === id;
          })[0];
          if (com) {
            commit('setSelectedCom', com);
            commit('setShowComponentForm', true);
          } else {
            console.log('根据id没有找到组件');
          }
        } else {
          console.log('没有页面数据');
        }
      }
    },
    set_scale_minus: function set_scale_minus(_ref4) {
      var state = _ref4.state,
        commit = _ref4.commit;
      var num = state.scale;
      num -= 5;
      commit("set_scale", num);
    },
    set_scale_plus: function set_scale_plus(_ref5) {
      var state = _ref5.state,
        commit = _ref5.commit;
      var num = state.scale;
      num += 5;
      commit("set_scale", num);
    }
  }
};
export default designCategory;